import React, { useState, useEffect } from "react";

import UserList from "./UserList";
import AdminSearchWidget from "../db-list/AdminSearchWidget";
import ListWrapper from "../../../common/management/ListWrapper";
import ListContentWrapper from "../../../common/management/ListContentWrapper";

import { genDisplayCount } from "../../../utils/GeneralUtils";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  getAdminUsers,
  getUsers,
  getAdminUserTotalEntries,
  getAdminUserTotalPages,
} from "../../../redux/reducers/adminUsers";
import { getAuthToken } from "../../../redux/reducers/auth";

type Props = {
  handleSearch?: (search: Array<string>) => void;
  handleAccountType?: (accountType: string) => void;
  currentPage: number;
  perView: number;
  search?: Array<string>;
  accountType?: string;
};

const UserListContainer: React.FC<Props> = ({
  handleSearch,
  handleAccountType,
  currentPage,
  perView,
  search,
  accountType,
}) => {
  const dispatch = useAppDispatch();
  const users = useAppSelector(getAdminUsers);
  const entries = useAppSelector(getAdminUserTotalEntries);
  const totalPage = useAppSelector(getAdminUserTotalPages);
  const auth_token = useAppSelector(getAuthToken);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (auth_token) {
      setIsLoading(true);

      const fetchUsers = dispatch(
        getUsers({
          auth_token: auth_token,
          isSelect: true,
          params: {
            page: currentPage,
            per: perView,
            search: search?.join(" "),
            desc: true,
            accountType: accountType,
          },
        })
      );

      fetchUsers.finally(() => setIsLoading(false));

      return () => {
        fetchUsers.abort();
      };
    }
  }, [perView, currentPage, auth_token, search, accountType]);

  return (
    <ListWrapper pageTitle={"会員一覧"}>
      <ListContentWrapper
        isLoading={isLoading}
        displayCount={genDisplayCount(currentPage, totalPage, perView, entries)}
        totalEntries={entries}
        handleAccountType={handleAccountType}
        currentPage={currentPage}
        accountType={accountType}
        totalPage={totalPage}
        optionalComponent={
          handleSearch && search ? (
            <AdminSearchWidget handleSearch={handleSearch} search={search} />
          ) : undefined
        }
      >
        <UserList users={users} />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default UserListContainer;
